
const initialState = {
    customQuestions: []
};

const state = Object.assign({}, initialState);

const getters = {
    customQuestions: state => state.customQuestions,
};

const mutations = {
    setCustomQuestions: (state, customQuestions) => (state.customQuestions = customQuestions),
};

export default {
    state,
    getters,
    mutations
};